import type { Device } from '@types';

/**
 * Determina il percorso dell'immagine per un device VR headset basato sul modello
 */
export const getVrDeviceImageSrc = (model?: string): string => {
  const modelLower = model?.toLowerCase() ?? '';

  if (modelLower.includes('quest 2')) {
    return '/meta-quest-2.webp';
  }
  if (modelLower.includes('quest 3s')) {
    return '/meta-quest-3s.webp';
  }
  if (modelLower.includes('quest pro')) {
    return '/meta-quest-pro.webp';
  }
  if (modelLower.includes('quest 3')) {
    return '/meta-quest-3.webp';
  }

  // Default fallback
  return '/meta-quest-3.webp';
};

/**
 * Determina il percorso dell'immagine per un sensore basato sul modello
 */
export const getSensorDeviceImageSrc = (model?: string): string => {
  const modelLower = model?.toLowerCase() ?? '';

  if (modelLower.includes('polar')) {
    return '/polar_360.webp';
  }

  // Default fallback per Galaxy e altri modelli
  return '/galaxy.avif';
};

/**
 * Determina il percorso dell'immagine per un device basato su tipo e modello
 */
export const getDeviceImageSrc = (device: Device): string => {
  if (device.type === 'vr-headset') {
    return getVrDeviceImageSrc(device.model);
  }

  // Per sensori (smartwatch)
  return getSensorDeviceImageSrc(device.model);
};

/**
 * Restituisce l'etichetta del tipo di device in italiano
 */
export const getDeviceTypeLabel = (type?: string): string => {
  if (type === 'vr-headset') return 'Visore';
  if (type === 'smartwatch') return 'Sensore';
  return type || 'N/A';
};
